// global
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// components
// import Page from 'app/components/pages/Page';
import Page from 'app/components/commons/layout/Page';
import SearchBox from 'app/components/commons/search/SearchBox';
import DefaultButton from 'app/components/commons/button/DefaultButton';
import AddButton from 'app/components/commons/button/AddButton';
import List from 'app/components/commons/layout/List';
import EmptyList from 'app/components/commons/emptyList/EmptyList';
import PopupHealthProfessional from './PopupHealthProfessional';
import HealthProfessionalModal from 'app/components/modals/health-professional/HealthProfessionalModal';
import HealthProfessionalChangeStatus from 'app/components/modals/health-professional/HealthProfessionalChangeStatus';
import ProfessionalsFilterDropdown from 'app/components/commons/dropdown/filters/ProfessionalsFilterDropdown';
// utils
import _ from 'lodash';
// redux
import { list, perPage, search, reset } from 'app/redux/actions/health-professional.action';
import { openSave } from 'app/redux/actions/modal/save-update-modal.action';
// stylesheet
import './HealthProfessional.scss';
import styles from './HealthProfessional.module.scss';
//config
import { COLORS } from 'app/config/colors';

function HealthProfessional(props) {
  const initialState = {
    title: 'Profissionais de saúde',
    filter: {
      perPage: 15,
      page: 1,
      search: '',
      professionId: null,
      businessPartner: null
    }
  };

  const [state, setState] = useState(initialState);

  useEffect(() => {
    props.dispatch(list(state.filter));

    return () => props.dispatch(reset());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderEmpty = () => <EmptyList emptyMessage='Nenhum profissional encontrado' />;

  const onSearchChange = value => {
    setState(state => ({
      ...state,
      filter: {
        ...state.filter,
        search: value
      }
    }));
    // callSearch(value);
  };

  const callSearch = value => {
    if (value) {
      props.dispatch(
        search({
          ...state.filter,
          page: 1,
          search: value
        })
      );
    }
  };

  const clearFilters = () => {
    if (state.filter.search || state.filter.professionId || state.filter.businessPartner) {
      setState(initialState);
      props.dispatch(list(state.filter));
    }
    // props.dispatch(reset());
  };

  const onClickIncreaseListLimit = () => {
    const listParams = state.filter;
    const page = listParams.page + 1;

    setState(state => ({ ...state, filter: { ...listParams, page } }));
    props.dispatch(
      perPage({
        ...listParams,
        perPage: listParams.perPage,
        page
      })
    );
  };

  const onChangeProfessionalFilter = (e, target) => {
    const { value } = target || e.target;

    setState(state => ({
      ...state,
      filter: {
        ...state.filter,
        professionId: value
      }
    }));

    props.dispatch(
      search({
        ...state.filter,
        professionId: value
      })
    );
  };

  const onClickCreate = () => () => props.dispatch(openSave());

  const renderTable = () => {
    return (
      <List
        columns={columns}
        rows={healthProfessionals}
        onClickIncreaseList={onClickIncreaseListLimit}
      />
    );
  };
  const statusNode = professional => {
    const isActive = professional.status === 1;
    const statusName = isActive ? 'ATIVO' : 'INATIVO';

    return (
      <div
        style={{
          color: isActive ? COLORS.ALERT_POSITIVE : COLORS.ALERT_NEGATIVE
        }}
      >
        {statusName}
      </div>
    );
  };

  const addressNode = professional => {
    return (
      <div>
        {`${professional.address.address || '--'}${
          professional.address.number ? `, ${professional.address.number}` : ''
        }`}
        {professional.address.state && professional.address.city && (
          <small>
            {professional.address.state}, {professional.address.city}
          </small>
        )}
      </div>
    );
  };

  const onKeyPressCallSearch = (e, term) => {
    if (e.key === 'Enter' && term) {
      callSearch(term);
    }
  };

  const columns = [
    {
      id: 1,
      width: 2,
      textAlign: 'left',
      headerTag: 'cpf',
      property: 'cpf'
    },
    {
      id: 2,
      width: 3,
      textAlign: 'left',
      headerTag: 'nome',
      property: 'name'
    },
    {
      id: 3,
      width: 2,
      textAlign: 'left',
      headerTag: 'profissão',
      property: 'profession.name'
    },
    {
      id: 4,
      width: 2,
      textAlign: 'left',
      headerTag: 'telefone',
      property: 'contact.phone'
    },
    {
      id: 5,
      width: 2,
      textAlign: 'left',
      headerTag: 'endereço',
      bodyNode: addressNode
    },
    { id: 6, width: 2, textAlign: 'center', headerTag: 'status', bodyNode: statusNode },
    {
      id: 7,
      width: 2,
      textAlign: 'center',
      headerTag: '',
      bodyNode: row => <PopupHealthProfessional row={row} />
    }
  ];

  const { healthProfessional } = props;
  const { filter, loading } = healthProfessional;
  const healthProfessionals = filter.data;

  return (
    <Page id='page' loading={loading}>
      <Page.Title title={state.title} />

      <Page.Content>
        <div className={styles.pageFilter}>
          <div>
            <SearchBox
              labelText='Pesquisar'
              placeholder='Pesquisar...'
              popupSearchText='Pesquisar por nome'
              value={state.filter.search}
              onKeyPress={e => onKeyPressCallSearch(e, state.filter.search)}
              onChange={e => onSearchChange(e.target.value)}
              onClick={() => callSearch(state.filter.search)}
            />
            <ProfessionalsFilterDropdown
              showLabel={false}
              value={state.filter.professionId}
              onChange={onChangeProfessionalFilter}
            />
          </div>

          <div className={styles.clearAndAdd}>
            <DefaultButton
              tag={<u>LIMPAR</u>}
              size='small'
              onClick={clearFilters}
              color={COLORS.PRIMARY_VARIANT}
              colorHover={COLORS.WHITE_VARIANT}
              backgroundColor={COLORS.TRANSPARENT}
              backgroundColorHover={COLORS.PRIMARY_VARIANT}
              borderColor={COLORS.TRANSPARENT}
              borderColorHover={COLORS.PRIMARY_VARIANT}
            />
            <AddButton onClick={onClickCreate()} />
          </div>
        </div>
      </Page.Content>
      <Page.Content>{_.isEmpty(healthProfessionals) ? renderEmpty() : renderTable()}</Page.Content>

      <HealthProfessionalModal />
      <HealthProfessionalChangeStatus />
    </Page>
    // <Page id={styles.pageSimpleList} loading={loading}>
    //   <div className={styles.shadow}></div>

    //   <div className={styles.backButton}>
    //     <i aria-hidden='true' className={styles.btnBack}>
    //       <Icon name='angle left'></Icon>
    //     </i>
    //     <div className={styles.backTitle}>PROFISSIONAIS DE SAÚDE</div>
    //   </div>

    //   <div className={styles.page}>
    //     <div className={styles.pageHeader}>
    //       <div className={styles.filters}>
    //         <Input
    //           //id='HealthProfessional-search'
    //           icon='search'
    //           placeholder='Pesquisar'
    //           className={styles.searchInput}
    //           onChange={onSearchChange}
    //           value={state.filter.search}
    //         />
    //         <ProfessionalsFilterDropdown
    //           showLabel={false}
    //           value={state.filter.professionId}
    //           onChange={onChangeProfessionalFilter}
    //         />
    //         <CleanFilterButton onClick={clearFilters} />
    //       </div>
    //       <AddButton onClick={onClickCreate()} />
    //     </div>

    //     <div className={styles.pageBody}>
    //       {isEmpty(healthProfessionals)
    //         ? renderEmpty()
    //         : renderTable(healthProfessionals, account, loading)}
    //     </div>
    //   </div>
    //   <HealthProfessionalModal />
    //   <HealthProfessionalChangeStatus />
    // </Page>
  );
}

HealthProfessional.propTypes = {
  healthProfessional: PropTypes.object,
  auth: PropTypes.object,
  dispatch: PropTypes.func
};

const mapStateToProps = state => ({
  healthProfessional: state.healthProfessional,
  auth: state.auth
});

export default connect(mapStateToProps)(HealthProfessional);
